module.exports = __webpack_public_path__ + "static/media/GBR.535e4452.png";